import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { useFlashData } from '../intake/intakeQueries';
import { FlashDetailsTable } from './FlashDetailsTable';

export const FlashDetailsUI = () => {
    const {
        data,
        isLoading,
        isError,
        refetch,
    } = useFlashData();

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                <CircularProgress />
            </div>
        );
    }

    if (isError) {
        return (
            <Typography color="error" align="center" style={{ padding: '2rem' }}>
                Failed to load flash report history.
            </Typography>
        );
    }

    return (
        <div>
            <FlashDetailsTable data={data || []} refetch={refetch} />
        </div>
    );
};


